import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { DataService } from '../data.service';

@Injectable({
  providedIn: 'root'
})
export class GroupHotelGuardService implements CanActivate {

  constructor(
    private dataServ: DataService,
    private router: Router
  ) { }

  async canActivate(): Promise<boolean> {

    if (!environment.hotelId) {
      this.router.navigateByUrl('/hotels');
      return false;
    }

    if (!this.dataServ.rData) {
      await this.dataServ.getRichData();
      await this.dataServ.removeDateRange(this.dataServ.baseData);
    }

    return true;

  }
}
